(function () {
  if (window.__cdxCoupledGiftInit) return;
  window.__cdxCoupledGiftInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BUSY = false;

  function props(item) {
    return item.properties || {};
  }

  function isBed(item) {
    return !!props(item)['_gift_variant'];
  }

  function isGift(item) {
    return !!props(item)['_bundle_parent_variant'];
  }

  function findNeededMutation(cart) {
    var beds = cart.items.filter(isBed);
    var gifts = cart.items.filter(isGift);

    for (var i = 0; i < gifts.length; i++) {
      var g = gifts[i];
      var parentVariant = String(props(g)['_bundle_parent_variant']);
      var parentPresent = beds.some(function (b) {
        return String(b.id) === parentVariant;
      });
      if (!parentPresent) {
        return { kind: 'change', body: { id: g.key, quantity: 0 } };
      }
    }

    for (var j = 0; j < beds.length; j++) {
      var b2 = beds[j];
      var giftVariant = parseInt(props(b2)['_gift_variant'], 10);
      if (!giftVariant) continue;

      var match = gifts.filter(function (g2) {
        return String(props(g2)['_bundle_parent_variant']) === String(b2.id);
      })[0];

      if (!match) {
        return {
          kind: 'add',
          body: {
            id: giftVariant,
            quantity: b2.quantity,
            properties: { _free_gift: 'true', _bundle_parent_variant: String(b2.id) }
          }
        };
      }

      if (match.quantity !== b2.quantity) {
        return { kind: 'change', body: { id: match.key, quantity: b2.quantity } };
      }
    }

    return null;
  }

  function run(cart) {
    if (BUSY || !cart || !cart.items) return;

    var mutation = findNeededMutation(cart);
    if (!mutation) return;

    BUSY = true;
    var url = ROOT + (mutation.kind === 'add' ? 'cart/add.js' : 'cart/change.js');

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(mutation.body)
    })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        BUSY = false;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        fetchAndRun();
      })
      .catch(function () {
        BUSY = false;
      });
  }

  function fetchAndRun() {
    fetch(ROOT + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(run)
      .catch(function () {});
  }

  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart && cart.items) run(cart);
    else fetchAndRun();
  });

  document.addEventListener('DOMContentLoaded', fetchAndRun);
})();
